import { createSearchParams } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { MassPayoutsPageView } from "@src/pages/massPayouts/crypto"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { ManualPayoutsStepUi } from "@src/widgets/onboarding/ui/tours/MassCrypto/steps/ManualPayoutsStepUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class ManualPayoutsStep extends TourStepBase {
  component = ManualPayoutsStepUi
  name = `${ONBOARDING_TOURS.MASS_CRYPTO}_ManualPayouts`

  constructor() {
    super({
      highlightElements: ["#GENERATED_ID_MASSPAYOUTSFORM_FORM_VOID_1"],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM_LEFT,
    })
  }

  action() {
    return router.navigate({
      pathname: paths.massPayouts,
      search: `?${createSearchParams({ view: MassPayoutsPageView.MANUAL })}`,
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      subtitle: "Process individual payouts directly",
      title: "Manual Payouts",
    }
  }
}
